import { render } from "./TeamSettingsBox.vue?vue&type=template&id=46863992&scoped=true"
import script from "./TeamSettingsBox.vue?vue&type=script&lang=js"
export * from "./TeamSettingsBox.vue?vue&type=script&lang=js"

import "./TeamSettingsBox.vue?vue&type=style&index=0&id=46863992&scoped=true&lang=css"

import exportComponent from "/Users/georgeconstantine/Documents/import/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46863992"]])

export default __exports__